import defaultAttributes from '../defaultAttributes';

const Trash = [
  'svg',
  defaultAttributes,
  [
    ['polyline', { points: '3 6 5 6 21 6' }],
    [
      'path',
      {
        d:
          'M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2',
      },
    ],
  ],
];

export default Trash;
